<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.12.14</b> - AI & bug fixes, game balance</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Inn: Increased maintain/upgrade peanut thresholds again</li>
      <li>
        Balance:
        <ul>
          <li>
            - Lightning AP/MP costs adjusted
            <ul>
              <li class="pl-4">* AP Cost: <code>25</code> --> <code>40 - L</code></li>
              <li class="pl-4">
                * MP Cost: <code>50 + L*4</code> -->
                <code>30 + L*3</code>
              </li>
            </ul>
          </li>
          <li>
            - Summon Dwarf/Elf/Faerie MP cost adjusted:
            <code>100 + L*40</code> --> <code>150 + L*25</code>
          </li>
          <li>
            - Holy force AP cost increased: <code>10</code> -->
            <code>40 - L</code>
          </li>
          <li>- Dwarves: removed Shield Block and added Slam</li>
          <li>
            - Slam knockback reduced: <code>2 + L*( St/80 )</code> -->
            <code>1 + L*( St/120 )</code>
          </li>
        </ul>
      </li>
      <li>
        AI
        <ul>
          <li>
            - Fixed a bug causing units sometimes to act before the result of the previous
            ability was calculated (e.g. shooting arrows at dead targets, double-casting
            CC).
          </li>
          <li>
            - Fixed several bugs causing units sometimes to run back & forth aimlessly
          </li>
          <li>- In PvP, the Interference tree now only targets enemy heroes</li>
          <li>
            - Only in Caverns will DoT abilities be spread around evenly. In PvP they'll
            now focus down one hero target.
          </li>
          <li>
            - Archers should no longer melee attack adjacent enemies when they have the
            opportunity to step back & shoot
          </li>
          <li>- Tanks will no longer target stunned enemies with Taunt</li>
          <li>- Increased the chances for DPS Close units to use Sky Hammer and Slam</li>
          <li>
            - Support units now consider groups of 2+ allies (from 3) as a "cluster" for
            AoE heals
          </li>
          <li>- Units will no longer use Adrenaline while feared</li>
        </ul>
      </li>
      <li>Fixed bugs preventing use of XP Potions / Candles from hero inventory</li>
      <li>Fixed a bug causing summoned units' puppets sometimes not to appear</li>
      <li>Added SFX to Razor Shot and Blunt Arrow</li>
      <li>Tweaked renderings for Scared, Enraged, Road to Nowhere, Infect Mind</li>
    </ul>
  </div>
</template>
